module.exports = __webpack_public_path__ + "assets/img/dzh-18.5cfc4472.jpg";